import eventBanner from '../../misc/GBC SPRING26_Banner.png';
import eventBannerSquare from '../../misc/puppetShow.jpg';

import { useState, useEffect } from 'react';

export default function GenericShowPage () {
    // for later <p><span className='underline'>Recommended Charitable Donation</span>: $15 or $20 per person. Receipts available. You can also save time by donating in advance to our <a className='innerLink' href='/summer-fundraiser'>Birdies for Charity</a> summer fundraiser. All givers of $100+ are acknowledged as annual sponsors in our program (time allowing), on our Donations page, and on the VR website. </p>
    const [currentBanner, setCurrentBanner] = useState(eventBanner);
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth <= 800) {
                setCurrentBanner(eventBannerSquare);
            } else {
                setCurrentBanner(eventBanner);
            }
        };

        // Initial check
        handleResize();

        // Add event listener
        window.addEventListener('resize', handleResize);

        // Cleanup
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <>
        <h1 className="h1 text-center w-11/12 m-auto pt-8 pb-12" id="subPageHeaderTitle">Expedition Five: A Barbershop A Cappella Space Opera</h1>
            <div className='w-11/12 m-auto mt-0'>
                <div className='text-justify pb-10'>
                    <div className='bg-slate-800 rounded-2xl p-5'>
                        <img 
                            className='m-auto h-[35%] w-[90%]' 
                            src={currentBanner} 
                            alt='Event Banner'
                        />
                            <br></br>
                            <br></br>
                            <div className='text-italic'>
                                <p>A distant future. </p>
                                <p>Earth is nothing more than a hazy memory.</p>
                                <p>Humanity wanders the endless universe in search of a new home.</p>
                                <p>And there’s only one person who can find it.</p>
                            </div>
                            <br></br>
                            <p>Come along on the journey in <span className='italic'>Expedition Five</span> a barbershop a cappella musical, written and performed by Vocal Revolution and VocaMotion choruses.</p>
                            <br></br>
                            <p>On <span className='text-underline'>Sunday May 31st at 2pm</span>, <span className='italic'>Expedition Five</span> will transform Somerville’s Arts At The Armory into a thrilling and heartfelt journey through space. The inspiring story - told through a selection of stirring a cappella performances - follows a team of explorers who must travel the hostile universe while navigating their own trials and triumphs. In the end, their mission becomes more than just discovering a new planet; they must also find a new idea of what it means to be brave.</p>
                            <p>Tickets will be available soon, so check back for more info! Please note that, as a 501c3 charitable organization, 100% of the proceeds from ticket sales and donations goes back into supporting high-quality music education and hosting stellar community events!</p>
                            <p>This event will feature the talents of:
                                <ul className='list-disc'>
                                    <li>Vocal Revolution</li>
                                    <li>VocaMotion</li>
                                </ul>
                            </p>
                            <p>And quartets:
                                <ul className='list-disc'>
                                    <li>TBD!</li>
                                </ul>
                            </p>
                            <br></br>
                            <p className='pb-1'><span className='underline'>Venue</span>:
                                <a className='innerLink' href='https://maps.app.goo.gl/CvkKifNQMdMA1dC28'> Arts at the Armory, 191 Highland Ave #1c, Somerville, MA 02143</a>
                            </p>
                            <p className='pb-1'><span className='underline'>Time</span>: 2pm on Sunday, May 31;  The show will have one short intermission. Doors open at 1:30pm.</p>
                            <p><span className='underline'>Recommended Charitable Donation</span>: $15 or $20 per person. Receipts available. You can also save time by donating in advance to our <a className='innerLink' href='/summer-fundraiser'>Birdies for Charity</a> summer fundraiser. All givers of $100+ are acknowledged as annual sponsors in our program (time allowing), on our Donations page, and on the VR website. </p>
                            <p className='pb-1'><span className='underline'>Tickets</span>: <a href="https://www.eventbrite.com/e/expedition-five-a-barbershop-a-cappella-space-opera-tickets-1986996795905?aff=oddtdtcreator" className="innerLink">Tickets Here!</a></p>
                    </div> 
                </div>
            </div>
        </>
    )
}